module.exports = __webpack_public_path__ + "img/b_shop_02.fc4cbc04.jpg";